export const sxContainer = () => ({
  px: { xs: 2, md: 14, lg: 20 },
  py: { xs: 2, md: 11 },
});

export const sxCenter = {
  maxWidth: '1120px',
  m: '0 auto',
};
